<template>
  <v-app>
    <Navbar></Navbar>
    <!-- Sizes your content based upon application components -->
    <v-content>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer>
      <!-- -->
      sdsd
    </v-footer>
  </v-app>
</template>

<script>
import Front from './components/Front';
import Navbar from './components/Navbar';

export default {
  name: 'App',
  components: {
    Front,
    Navbar
  },
  data: () => ({
    //
  })
};
</script>
